import MoveableManager from "./MoveableManager";

export default class Moveable extends MoveableManager {}
